import * as React from 'react';
import './Loading.css';
 
const Loading = (props) => (
  <div className="Pacman-wrapper">
    <div className="Pacman">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export {Loading};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/core/Loading/Loading.tsx